import React from 'react'

import MapContainer   from "./MapComponent"

const ContactMapCard = () => {
    return (
        <div className="content contacts">

            <div className="title">Get in Touch</div>

            <div className="row">
                <div className="col col-d-12 col-t-12 col-m-12 border-line-v">
                    <div className="map" id="map">
                        <MapContainer />
                    </div>
                    <div className="info-list">
                        <ul>
                            <li><strong>Address . . . . .</strong> Pune, Maharashtra, India</li>
                            <li><strong>Email . . . . .</strong> piyushtalele.6491@<br/>gmail.com</li>
                            <li><strong>Phone . . . . .</strong> +91 950 387 6614</li>
                        </ul>
                    </div>
                </div>
                <div className="clear"></div>
            </div>

        </div>
    );
}

export default ContactMapCard;